import {defaultBreadcrumbs, generateBreadcrumb} from 'src/app/models/screen-prop'

const AuditLogScreens = {
  LIST_AUDIT_LOG_SYNC: {
    PATH: '/audit-log/list',
    HEADER_NAME: 'Audit Log',
    TITLE: 'List Audit Log',
    TITLE_ALT: 'List Audit Log',
    PERMISSION: 'auditlog.read',
    breadcrumbs: defaultBreadcrumbs,
  },
  DETAIL_AUDIT_LOG_SYNC: {
    PATH: '/audit-log/list/detail/:id',
    TITLE: 'Detail',
    TITLE_ALT: 'Detail',
    PERMISSION: 'auditlog.read',
    breadcrumbs: defaultBreadcrumbs,
  },
}

const AuditLogBreadcrumbs = generateBreadcrumb([AuditLogScreens.LIST_AUDIT_LOG_SYNC])
AuditLogScreens.DETAIL_AUDIT_LOG_SYNC.breadcrumbs = () => AuditLogBreadcrumbs

export default AuditLogScreens
